const DEFAULT_API_URL = 'http://localhost:8080';
const GAME_PATH = '/game';
const WEBSOCKET_PATH = '/ws';

const trimTrailingSlashes = (value: string): string => value.replace(/\/+$/, '');

const appendPathOnce = (baseUrl: string, path: string): string => {
    const normalizedBaseUrl = trimTrailingSlashes(baseUrl);
    return normalizedBaseUrl.endsWith(path) ? normalizedBaseUrl : `${normalizedBaseUrl}${path}`;
};

export const API_BASE_URL: string = trimTrailingSlashes(
    process.env.REACT_APP_API_URL || DEFAULT_API_URL
);

export const REST_API_BASE_URL: string = appendPathOnce(API_BASE_URL, GAME_PATH);

export const WEBSOCKET_ENDPOINT_URL: string = appendPathOnce(API_BASE_URL, WEBSOCKET_PATH);
